import { BrowserRouter, Routes, Route } from "react-router";
import { Container } from "../components/layout";
import { SeoManager } from "./SeoManager";
import {
  //   Changelog,
  //   Contact,
  //   External1,
  //   External2,
  // NotFound,
  Home,
  AboutUs,
  Events,
  Booking,
  MassageServices,
  MatrixDropsProtocol,
  MatrixDrops,
  NotFound,
} from "../components/views";

export const Navigation = () => (
  <BrowserRouter>
    <SeoManager />
    <Routes>
      <Route path="/" element={<Container />}>
        <Route index element={<Home />} />
        <Route path="about-us" element={<AboutUs />} />
        <Route path="contact" element={<AboutUs />} />
        <Route path="events" element={<Events />} />
        <Route path="booking" element={<Booking />} />
        <Route path="massage-services" element={<MassageServices />} />
        <Route path="matrix-drops" element={<MatrixDrops />} />
        <Route path="matrix-drops-protocol" element={<MatrixDropsProtocol />} />
        {/* <Route path="changelog" element={<Changelog />} />
            <Route path="contact" element={<Contact />} />
            <Route path="external1" element={<External1 />} />
            <Route path="external2" element={<External2 />} /> */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  </BrowserRouter>
);
